import { useCheckOutFlowParams } from 'hooks/useCheckOutFlowParams';
import useExitCheckOutFlow from './useExitCheckOutFlow';
import { useCallback, useMemo } from 'react';
import { useParams } from 'react-router';
import { useDelivery } from 'api/hooks/useDelivery';
import { useCheckOutTraysBySet } from 'hooks/useCheckOutTraysBySet';
import { useVisibleCheckOutDialog } from 'hooks/useVisibleCheckOutDialog';

const useExitCheckOutFlowConfirm = () => {
  const { setVisibleCheckOutDialog } = useVisibleCheckOutDialog();
  const { checkOutFlowParams } = useCheckOutFlowParams();
  const [checkOutTraysBySet] = useCheckOutTraysBySet();

  const { deliveryId = checkOutFlowParams.deliveryId } = useParams();

  const { data: delivery } = useDelivery(deliveryId);

  const exitCheckOutFlow = useExitCheckOutFlow();

  const hasPartiallyCheckedOutSets = useMemo(
    () =>
      delivery?.sets.some(
        set =>
          checkOutTraysBySet[set.kitInstanceId] &&
          (!checkOutTraysBySet[set.kitInstanceId].trays ||
            (checkOutTraysBySet[set.kitInstanceId].trays &&
              Object.values(checkOutTraysBySet[set.kitInstanceId].trays).some(tray => !tray.completed))),
      ),
    [checkOutTraysBySet, delivery?.sets],
  );

  const exitCheckOutFlowConfirm = useCallback(() => {
    if (hasPartiallyCheckedOutSets) {
      setVisibleCheckOutDialog({
        type: 'INSPECTION_WARNING_DIALOG',
      });

      return;
    }

    exitCheckOutFlow(false);
  }, [exitCheckOutFlow, hasPartiallyCheckedOutSets, setVisibleCheckOutDialog]);

  return exitCheckOutFlowConfirm;
};

export default useExitCheckOutFlowConfirm;
